// extracted by mini-css-extract-plugin
export default {"container":"CountryProtectedPage_container__u2yZe","submit":"CountryProtectedPage_submit__akrQW","logo":"CountryProtectedPage_logo__nDhXs"};